import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { BsFacetCard, FacetViewDirective } from '@sinequa/components/facet';
import { PreviewService } from '@sinequa/components/preview';
import { SearchService } from '@sinequa/components/search';
import { UIService } from '@sinequa/components/utils';
import { MapOf } from '@sinequa/core/base';
import { IntlService } from '@sinequa/core/intl';
import { Results, Tab, Record, ListAggregation, TreeAggregation } from '@sinequa/core/web-services';
import { map, Observable, tap } from 'rxjs';
import { FilterModalComponent } from '../filter-modal/filter-modal.component';
import { ModalService } from '@sinequa/core/modal';
import { CustomService } from '../custom.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { boldStarPipe } from '../app.module'; // importing boldStarPipe for intending the chat app
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Renderer2 } from '@angular/core';
import { HtmlParserService } from '../html-parser.service';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  animations: [
    trigger('myState', [
      state('inactive', style({
        marginLeft: '-19em',
        transform: 'translateX(0) rotate(0) scale(1)'
      })),
      state('active', style({
        marginLeft: '0px',
        transform: 'translateX(0) rotate(0deg) scale(1)'
      })),
      transition('inactive => active', animate('0.1s ease-in')),
      transition('active => inactive', animate('0.1s ease-out'))
    ])
  ]
})
export class SearchComponent implements OnInit {
  response: any;
  asst_response:any;
  asst_context:any;
  copied: boolean = false;
  disableScrollDown: boolean = false;
  isAccordionVisible = false;
  additionalProperties: any;
  history: any[] = [];
  state = 'inactive';
  constructor(
    private parser: HtmlParserService,
    private _render: Renderer2,
    public clipboard: Clipboard,
    public customService: CustomService,
    private previewService: PreviewService,
    public searchService: SearchService,
    private titleService: Title,
    private intlService: IntlService,
    public ui: UIService,
    private boldStarPipe: boldStarPipe,
    private sanitizer: DomSanitizer,
    private modalService: ModalService) { }
  public results$: Observable<Results | undefined>;
  public btnLabels: Tab[] = [];
  // Document "opened" via a click (opens the preview facet)
  public openedDoc?: Record;

  /**
 * Controls visibility of filters (small screen sizes)
 */
  public showFilters = this.ui.screenSizeIsGreaterOrEqual('md');

  public recordResults: Record[];

  public selectedBtnName: string;

  public selectedBtnValue: string;

  public aggregations: MapOf<ListAggregation | TreeAggregation>;

  public title = 'Found';
  noOflines:any
  public passageId?: string;

  // Whether the left facet bar is shown
  public _showFilters = this.ui.screenSizeIsEqual('md');

  @ViewChild("previewFacet") previewFacet: BsFacetCard;

  @ViewChild("passagesList", { read: FacetViewDirective }) passagesList: FacetViewDirective;

  ngOnInit(): void {

    // calling chat application at initial load.
   if (this.searchService.query.text !== undefined) {
     this.customService?.tiggerSearchMethod()
    }
    this.customService?.additionalProperties.subscribe(
      (data) => {
        if (data) {
          console.log(data)
          this.history = data.slice(3, -1);
        }
      }
    )
    this.customService?.dataSubject.subscribe(
      (resp) => {
        this.asst_context = undefined;
        const res = resp?.content;
        if (res) {
          this.response = res;
          const lines = this.response.split(/\r\n|\r|\n/);
          this.noOflines = (lines.length);
          const parser = new DOMParser();

          const simpleFormat = (html) =>{
            return html.replace(/></g,'>\n<')
          }
          const r = this.boldStarPipe.transform(this.response)
          
          this.noOflines =  simpleFormat(r).split('\n').length * 25
          // alert(this.noOflines);
          this.asst_response = this.parser.parseHtml(r);
          this.asst_context = resp?.context;
          console.log(this.asst_response);
          
        }
      }
    )
    this.results$ = this.searchService.resultsStream
      .pipe(
        tap(results => {
          this.btnLabels = [];
          this.titleService.setTitle(this.intlService.formatMessage("msg#search.pageTitle", { search: this.searchService.query.text || "" }));
          if (!this.showResults) {
            this.openedDoc = undefined;
            this.showFilters = false;
          }

          if (results && results.records && results.records.length <= results.pageSize) {
            // Initialize aggregation map
            results.$aggregationMap = {};
            this.recordResults = results.records;
            if (results.tabs && results.tabs.length > 0) {
              results.tabs.forEach(tabName => {
                this.selectedBtnName = 'All Results';
                this.btnLabels.push(tabName);
              })
            }
            window.scrollTo({ top: 0, behavior: 'auto' });
            if (results.aggregations && results.aggregations.length > 0) {
              for (const aggregation of results.aggregations) {
                // Populate aggregation map
                results.$aggregationMap[aggregation.name.toLowerCase()] = aggregation;
              }
              this.aggregations = results.$aggregationMap;
            }
          }
        })
      );
  }
  /**
   * boldStarPipe for intending the chat app
   */
  // safeHtml$ = this.customService.dataSubject.pipe(map(data => {
  //   const boldStar = new boldStarPipe()
  //   const transformedData = boldStar.transform(data);
  //   return this.sanitizer.bypassSecurityTrustHtml(transformedData);
  // })
  // );
  /**
     * boldStarPipe for intending the chat app ends
     */
  /**
    * copy to clipboard for Insight valut
    */
  // copyToClipboard(): void {
  //   // this.clipboard.copy(this.response);
  //   // this.copied= true;
  //   // setTimeout(() =>  {
  //   //   this.copied = false;},2000);

    
  //   }

    copyToClipboard() {
      const valor:any = document.getElementById('elementToCopy')?.innerText;
      if(valor){
        this.clipboard.copy(valor);
        this.copied= true;
          setTimeout(() =>  { this.copied = false;} ,2000);
      }
      
  }


  /**
   * Determine whether to show or hide results
   */
  get showResults(): boolean {
    if (this.ui.screenSizeIsLessOrEqual('sm')) {
      return !this.showFilters && !this.openedDoc;
    }
    return true;
  }

  /**
     * Open modal on clicking filter icon 
     */

  showModal(results: any) {
    const data = {
      results: results,
      aggregations: this.aggregations
    }
    this.modalService.open(FilterModalComponent, { model: data });
    return false;
  }

  //clicking on look for button
  selectedBtn(btnDetails: Tab) {
    this.selectedBtnName = btnDetails.display;
    this.selectedBtnValue = btnDetails.value;
    this.searchService.selectTab(btnDetails);
  }
  /**
    * Responds to a click on a document (setting openedDoc will open the preview facet)
    * @param record
    * @param event
    */
  onDocumentClicked(record: Record, event: Event) {
    if (!this.isClickAction(event)) {
      this.openMiniPreview(record);
    }
  }

  // VERY SPECIFIC TO THIS APP:
  // Make sure the click is not meant to trigger an action (from sq-result-source or sq-result-title)
  private isClickAction(event: Event): boolean {
    if (event.type !== 'click') {
      return true;
    }
    const target = event.target as HTMLElement;
    if (!target) {
      return false;
    }
    return event.type !== 'click' ||
      target.tagName === "A" ||
      target.tagName === "INPUT" ||
      target.matches("sq-result-selector *, .sq-result-title, sq-result-source *, sq-labels *");
  }

  openMiniPreview(record: Record, passageId?: number) {
    this.openedDoc = record;
    this.openedDoc.$hasPassages = !!this.openedDoc.matchingpassages?.passages?.length;
    this.passageId = passageId?.toString();
    if (this.passageId) {
      if (this.previewFacet && this.passagesList) {
        this.previewFacet.setView(this.passagesList);
      }
    }
    if (this.ui.screenSizeIsLessOrEqual('md')) {
      this._showFilters = false; // Hide filters on small screens if a document gets opened
    }
  }

  /**
  * Open the preview when this record has no url1
  * @param record
  * @param isLink
  */
  openPreviewIfNoUrl(record: Record, isLink: boolean) {
    if (!isLink) {
      this.previewService.openRoute(record, this.searchService.query);
    }
  }
  openAcc() {
    this.isAccordionVisible = !this.isAccordionVisible;
  }
  toggleSidebar() {
    console.log("clicked");
    this.state = this.state === 'active' ? 'inactive' : 'active'; 
  }
}
